import { IconButtonProps, Stack, Tooltip, Typography } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { BiDownload } from 'react-icons/bi'

import BaseIconButton from '../BaseIconButton'

interface IExportButtonProps {
  onExport: () => void
}

function ExportButton(props: IExportButtonProps & IconButtonProps) {
  const { onExport, ...iconButtonProps } = props
  const { t } = useTranslation()

  return (
    <Tooltip title={<Typography variant="subtitle1">{t('common.export')}</Typography>} placement="bottom">
      <Stack width="fit-content">
        <BaseIconButton
          sx={{
            padding: 0,
          }}
          {...iconButtonProps}
          onClick={onExport}
        >
          <BiDownload style={{ cursor: 'pointer' }} />
        </BaseIconButton>
      </Stack>
    </Tooltip>
  )
}

export default ExportButton
